<template>
    <ValidationObserver :ref="stepName" v-slot="observer">
        <b-button type="button is-primary next-button" :disabled="block_form" v-html="step._button" @click="nextStep()"></b-button>
    </ValidationObserver>
</template>

<script>
import mixin from "../../../travel_step_mixin";
import form_step_mixin from '../../../form_step_mixin'
import {Text} from "../../../../../../models/fields/Text";
import {Select} from "../../../../../../models/fields/Select";
import {Option} from "../../../../../../models/fields/Features/Option";
import form_data from "../../../../../../store/modules/data/form_data";


export default {
    mixins: [mixin,form_step_mixin],
}
</script>
